module.exports = __webpack_public_path__ + "img/popupAd-day12.fd77dec3.png";